<template>
  <PropertyComponentProvider>
    <div class="flex flex-1 flex-col">
      <MRow v-if="!hideAttributeDrawer" :gutter="0" class="h-0">
        <MCol class="text-right relative">
          <AddAttributeDrawer
            :default-selected-columns="(value || []).map((v) => v.key)"
            :available-columns="availableColumns"
            :disabled="disabled"
            @submit="handleSubmit"
          >
            <template v-slot:trigger="{ open }">
              <a
                :style="
                  isRtl
                    ? { position: 'absolute', top: '-26px', left: '2px' }
                    : { position: 'absolute', top: '-26px', right: '2px' }
                "
                @click="open"
              >
                {{ $tc('add') }} {{ $tc('attribute', 2) }}
              </a>
            </template>
          </AddAttributeDrawer>
        </MCol>
      </MRow>
      <div class="flex flex-col flex-1">
        <SelectedBaselineAttributeList
          v-model="attributes"
          :disabled="disabled"
          :available-columns="availableColumns"
        />
      </div>
    </div>
  </PropertyComponentProvider>
</template>
<script>
import PropertyComponentProvider from '@modules/asset/components/propery-component-list/property-component-provider'
import { generateId } from '@utils/id'
import { getSupportedDataApi } from '@modules/asset-management/api/manage-baseline-api'
import SelectedBaselineAttributeList from './selected-baseline-attribute-list'
import AddAttributeDrawer from './add-attribute-drawer'
import { authComputed } from '@state/modules/auth'

export default {
  name: 'BaselineAttributeComponent',
  components: {
    SelectedBaselineAttributeList,
    AddAttributeDrawer,
    PropertyComponentProvider,
  },
  model: {
    event: 'change',
  },
  props: {
    value: {
      type: Array,
      default() {
        return []
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideAttributeDrawer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      availableColumns: [],
    }
  },
  computed: {
    ...authComputed,

    attributes: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('change', value)
      },
    },
  },
  created() {
    this.getSupportData()
  },
  methods: {
    getSupportData() {
      getSupportedDataApi().then((data) => {
        this.loading = false
        this.availableColumns = data.items
        // this.getDefaultSelection(this.defaultSelectedColumns)
      })
    },
    handleSubmit(attributes) {
      const selectedAttributes = this.value.filter(
        (v) => attributes.map((a) => a.key).indexOf(v.key) >= 0
      )
      const newAttributes = attributes.filter(
        (a) => this.value.map((v) => v.key).indexOf(a.key) === -1
      )
      this.$emit('change', [
        ...(selectedAttributes || []),
        ...(newAttributes.map((a) => ({ ...a, guid: generateId() })) || []),
      ])
    },
    handleRemove(item) {
      const attributes = this.value.filter((v) => v.key !== item.key)
      this.$emit('change', attributes)
    },
  },
}
</script>
